import { Box, Button, Container, Stack, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { Link as RouterLink } from 'react-router-dom';

export function GetStartedSection() {
  return (
    <Box component="section" sx={{ py: { xs: 6, md: 8 }, bgcolor: 'background.default' }}>
      <Container maxWidth="md">
        <Box
          sx={{
            bgcolor: 'background.paper',
            p: { xs: 4, md: 6 },
            borderRadius: 2,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontSize: { xs: '1.75rem', md: '2.25rem' } }}
          >
            Ready to get started?
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ mb: { xs: 3, md: 4 } }}
          >
            Apply Now or Contact us
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Button
              variant="contained"
              size="large"
              color="secondary"
              component={RouterLink}
              to="/apply"
              fullWidth={true}
            >
              Get Started
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<EmailIcon />}
              color="secondary"
              component={RouterLink}
              to="/contact-us"
              fullWidth={true}
            >
              Contact Us
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}